import React, { Component } from 'react';

class Button extends Component {
	render() {
		return (
			<button className="button is-medium btn-blue" type={this.props.type || 'button'} value={this.props.value || null}>
				<span className="icon">
					<i className="fab fa-telegram-plane" />
				</span>
				<span>{this.props.text}</span>
			</button>
		);
	}
}
export default Button;
